import { c as o } from "./createLucideIcon-OVU-vHz1.js";
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], e = o("chevron-right", t);
export {
  e as C
};
